import { Identity } from '@/libs/identity/identity';
import { ZustandGet } from '../stores.types';
import { OnboardingState, OnboardingStore } from './onboarding.types';

/**
 * Pure snapshot check: a sign-up for the stored secret key was started or completed on the homeserver, so that key
 * may already own an account the auth store does not hold a session for (`AuthController.signUp` records the
 * attempt before it signs the created account in). Compared through the secret, not `currentUserPubky`: the pubky
 * generated by the onboarding key step is not persisted across reloads while the secret and the attempt are.
 */
export const hasSignupAttemptForSecretState = (state: Pick<OnboardingState, 'secretKey' | 'signupAttempt'>): boolean =>
  state.secretKey !== null &&
  state.signupAttempt !== null &&
  Identity.tryZ32FromSecret(state.secretKey) === state.signupAttempt.pubky;

export const createOnboardingSelectors = (get: ZustandGet<OnboardingStore>) => ({
  /**
   * Gets the secret key (private key) from the keypair
   * @returns The secret key as a hex string
   * @throws Error if keypair is not available
   */
  selectSecretKey: () => {
    const secretKey = get().secretKey;
    if (!secretKey) {
      // TODO: Specific error type
      throw new Error('Secret key is not available. Please generate first.');
    }
    return secretKey;
  },

  /**
   * Gets the mnemonic recovery phrase
   * @returns The mnemonic as a string
   * @throws Error if mnemonic is not available
   */
  selectMnemonic: () => {
    const mnemonic = get().mnemonic;
    if (!mnemonic) {
      // TODO: Specific error type
      throw new Error('Mnemonic is not available. Please generate a keypair first.');
    }
    return mnemonic;
  },
});
